import styled from 'styled-components';
import { animated } from 'react-spring';

const Icon = styled(animated.span)`
    display: flex;
    margin-left: 0.5rem;
`;

export default Icon;
